import axios, { AxiosRequestConfig } from "axios";
import { Toast } from "react-vant";


const isDouyinById = window.location.pathname.startsWith('/web/douyin-auth')
axios.defaults.baseURL = isDouyinById ? "https://dev.api.zxaigc.com/" : "https://www.zxaigc.com/"
axios.defaults.baseURL = "https://www.zxaigc.com/";

axios.defaults.timeout = 1000 * 180;

interface AxiosErrorInterface {
  message: string;
  config: any;
  response: any;
}

axios.interceptors.request.use(
  (config: any) => {
    let _config = {};
    if (document.title === "云视AI获客") {
      _config = { Aid: 1002 };
    }
    // eslint-disable-next-line no-param-reassign
    config.headers = {
      ...config.headers,
      Token: localStorage.getItem("token"),
      Device: "app",
      ..._config,
    };
    return config;
  },
  (error: AxiosErrorInterface) => {
    return error;
  }
);

axios.interceptors.response.use(
  (response: any) => {
    if (response.status !== 200) {
      if (response.status === 401) {
        console.log("登录失效");
        return Promise.reject(response);
      }
    }
    return Promise.resolve(response);
  },
  (error: AxiosErrorInterface) => {
    if (error.response && error.response.status === 401) {
      Toast({
        message: "登录失效",
      });
      return Promise.reject(error);
    }

    if (error.response && error.response.data.message) {
      // 自行替换提示
      // eslint-disable-next-line no-console
      console.log(error.response.data.message);
    }
    return Promise.reject(error);
  }
);

const request = (url: string, config?: AxiosRequestConfig): Promise<any> => {
  const _config = {
    url,
    ...config,
  };
  return axios.request(_config);
};

export default request;
